/* angular:styles/component:css;0535f3a62beb90d5ea4de0cbbf48c6900044f21fe844c53b20f918f2010da640;/opt/atlassian/pipelines/agent/build/src/app/line-sample.component.ts */
:host {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
canvas {
  display: block;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
/*# sourceMappingURL=line-sample.component.css.map */
